const useEnv = () => {
    const isProduction = process.env.VITE_ENVIRONMENT === 'production';
    const env = isProduction ? 'prod' : 'staging';
    const isMultiAssignEnabled = true;
    const showLightControlPanel = true;
    return {
        env,
        isProduction,
        isMultiAssignEnabled,
        showLightControlPanel,
        readingProfileApiUrl: `https://api.eu.${env}.ilteducation.com/reading-profile`,
        contentSearchApiUrl: `https://api.global.${env}.ilteducation.com/content-search`,
        contentRegistryApiUrl: `https://api.global.${env}.ilteducation.com/content-registry`,
        audioCentralApiUrl: `https://api.global.${env}.ilteducation.com/audio-central`,
        contentCollectionsApiUrl: `https://api.eu.${env}.ilteducation.com/content-collections`,
        authClientId: `${isProduction ? '9t4b3bA2LCt3YodCq3iA' : '89w6MJksUyIuNRX1gaks'}`,
    };
};

export default useEnv;
